export default function getStickyContentBlockLeftProps(isSticky: boolean) {
  return {
    alignSelf: "flex-start",
    maxH: {
      base: "none",
      lg: isSticky ? "calc(100vh - 72px)" : "none",
    },
    overflowY: {
      base: "visible",
      lg: isSticky ? "auto" : "visible",
    },
    position: {
      base: "static",
      lg: isSticky ? "sticky" : "static",
    },
    top: {
      base: "auto",
      lg: "72px",
    },
  } as const
}
